(() => {
  const section = document.querySelector('.tf-b2b');
  const container = section?.querySelector('[data-forms-id="forms-root-1207909"]');
  if (!section || !container) return;
  const css = `
    *, *::before, *::after { box-sizing:border-box; }
    :host { --inline-container-max-width:100% !important; --container-max-w:100% !important; --forms-body-font:inherit !important; --form-field-border-radius:var(--tf-b2b-radius,8px) !important; --button-border-radius:var(--tf-b2b-radius,8px) !important; }
    [data-sizing="form-wrapper"], [class*="_gridItemContent_"] { width:100%; max-width:100%; min-width:0; }
    [class*="_formHeader_"] { display:none; }
    form[data-testid="form"] { display:grid !important; grid-template-columns:repeat(2,minmax(0,1fr)); gap:20px; align-items:start; width:100% !important; }
    form[data-testid="form"] > * { min-width:0; margin:0; width:100%; }
    form[data-testid="form"] > div:first-child:not(:has(input)) { grid-column:1/-1; }
    form[data-testid="form"] > button[type="submit"] { grid-column:1/-1; width:220px; justify-self:center; margin-top:12px; }
    input, textarea, select { font-size:16px !important; }
    [class*="_formDisclaimer_"] { margin-top:20px; }
    @media(min-width:750px) {
      form > div:has(> input[id^="custom#tk"]) { align-self:end; }
      form > div:has(> p[id="custom#country-selector-label"]) > button { height:52px !important; min-height:52px !important; max-height:none !important; }
    }
    @media(max-width:749px) { form[data-testid="form"] {grid-template-columns:minmax(0,1fr);gap:16px;} form[data-testid="form"] > button[type="submit"] {width:100%;} }
  `;
  // Styling only: keep Shopify's fields, validation, consent and submission untouched.
  const apply = () => {
    const host = container.querySelector('shopify-forms-embed');
    const root = host?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-tf-b2b-style]')) {
      const style = document.createElement('style');
      style.dataset.tfB2bStyle = 'true';
      style.textContent = css;
      root.appendChild(style);
    }
    return true;
  };
  if (apply()) return;
  const observer = new MutationObserver(() => {
    if (apply()) observer.disconnect();
  });
  observer.observe(container, { childList:true, subtree:true });
  window.setTimeout(() => observer.disconnect(), 60000);
})();